var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 14.761V8.1h15.75v6.715c0 2.746-1.729 4.435-4.495 4.435H7.11c-2.74 0-4.486-1.724-4.486-4.489zm4.34-2.152a.719.719 0 01-.744-.7c0-.402.311-.734.709-.753.389 0 .709.307.717.7a.719.719 0 01-.683.753zm3.552 0a.719.719 0 01-.743-.7c0-.402.311-.734.709-.753.389 0 .708.307.717.7a.719.719 0 01-.683.753zm3.527 3.22a.741.741 0 01-.717-.744.727.727 0 01.709-.743h.008c.406 0 .735.333.735.743a.739.739 0 01-.735.744zm-4.27-.744a.72.72 0 00.743.7c.39-.017.7-.35.683-.752a.715.715 0 00-.717-.7.748.748 0 00-.71.752zm-3.562 0a.72.72 0 00.744.7c.389-.017.7-.35.683-.752a.715.715 0 00-.718-.7.748.748 0 00-.709.752zm7.123-3.184c0-.403.311-.726.71-.735.388 0 .7.314.717.7a.713.713 0 11-1.426.044v-.01z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.629 8.1c.011-.514.054-1.533.136-1.861.415-1.846 1.824-3.018 3.838-3.185H14.4c1.997.176 3.423 1.356 3.838 3.185.08.319.124 1.346.135 1.86H2.629z",
    fill: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.267 5.766c.38 0 .666-.288.666-.673V2.425a.654.654 0 00-.666-.675.654.654 0 00-.665.675v2.668c0 .385.285.673.665.673zM13.734 5.766a.659.659 0 00.666-.673V2.425a.66.66 0 00-.666-.675.654.654 0 00-.666.675v2.668c0 .385.286.673.666.673z",
    fill: "#ED1B2E"
  })));
}

export default SvgIconly;